export default __webpack_public_path__ + "static/8-d272222b959a55ed8ea060b8568a1669.png";